import React, { useState } from "react";
import theme from "../../../styles/theme";

const DropdownIcones = ({
  label,
  options = [],
  value,
  onChange,
  placeholder = "Menu",
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (optionValue) => {
    if (disabled) return;
    onChange(optionValue);
    setOpen(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {/* Label au-dessus si nécessaire */}
      {label && (
        <label
          style={{
            display: "block",
            marginBottom: theme.spacing.xs,
            fontWeight: 500,
          }}
        >
          {label}
        </label>
      )}

      {/* Bouton principal */}
      <div
        onClick={() => !disabled && setOpen(!open)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: theme.spacing.sm,
          border: `1px solid ${theme.colors.borders.default}`,
          borderRadius: theme.borders.radius.sm,
          padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
          backgroundColor: disabled
            ? theme.colors.states.disabled
            : theme.colors.background.input,
          cursor: disabled ? "not-allowed" : "pointer",
          userSelect: "none",
          minWidth: "160px",
        }}
      >
        {options.find((o) => o.value === value)?.icon && (
          <img
            src={options.find((o) => o.value === value)?.icon}
            alt=""
            style={{
              width: 20,
              height: 20,
              objectFit: "contain",
            }}
          />
        )}
        <span>
          {options.find((o) => o.value === value)?.label || placeholder}
        </span>
        <span
          style={{
            marginLeft: "auto",
            fontSize: 12,
            color: theme.colors.text.muted,
          }}
        >
          ▼
        </span>
      </div>

      {/* Liste déroulante */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            minWidth: "180px",
            marginTop: 4,
            border: `1px solid ${theme.colors.borders.default}`,
            borderRadius: theme.borders.radius.sm,
            backgroundColor: theme.colors.background.surface,
            boxShadow: "0 4px 8px rgba(0,0,0,0.06)",
            zIndex: 9999,
            maxHeight: "240px",
            overflowY: "auto",
          }}
        >
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => handleSelect(opt.value)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.sm,
                padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                cursor: "pointer",
                backgroundColor:
                  value === opt.value
                    ? theme.colors.background.muted
                    : "transparent",
                color: theme.colors.text.default,
                transition: "background-color 0.2s",
              }}
            >
              {opt.icon && (
                <img
                  src={opt.icon}
                  alt=""
                  style={{
                    width: 18,
                    height: 18,
                    objectFit: "contain",
                  }}
                />
              )}
              <span>{opt.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownIcones;
